import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./reducers/userSlice";
import bookingDataReducer from "./reducers/flight/flightBookingSlice";
import filterSlice from "./reducers/tour/filterSlice";
import tabSlice from "./reducers/tour/tabSlice";
import tourDataSlice from "./reducers/tour/tourDataSlice";
import hotelDataSlice from "./reducers/tour/hotelDataSlice";
import dataSlice from "./reducers/tour/dataSlice";
import modalSlice from "./reducers/modalSlice";
import orderSlice from "./reducers/orderSlice";
import settingsSlice from "./reducers/settings/accountSettingsSlice";
import academySettingSlice from "./reducers/settings/academySettingSlice";
import bannerSettingSlice from "./reducers/settings/bannerSettingSlice";
import paymentSettingsSlice from "./reducers/settings/paymentSettingsSlice";
import currenciesSlice from "./reducers/settings/currenciesSlice";
import supplierSettingsSlice from "./reducers/settings/supplierSettingsSlice";
import pointsSlice from "./reducers/pointsSlice";

export const store = configureStore({
  reducer: {
    flightBooking: bookingDataReducer,
    user: userReducer,
    tourFilter: filterSlice,
    tabSlice: tabSlice,
    tourData: tourDataSlice,
    hotelData: hotelDataSlice,
    data: dataSlice,
    modal: modalSlice,
    order: orderSlice,
    settings: settingsSlice,
    paymentSettings: paymentSettingsSlice,
    academySettings: academySettingSlice,
    bannerSettings: bannerSettingSlice,
    currencies: currenciesSlice,
    supplierSettings: supplierSettingsSlice,
    points: pointsSlice,
  },
});
